module.exports = __webpack_public_path__ + "static/media/logo.9566ec10.png";